import React, { Component } from "react";
import { Redirect } from "react-router";
import { Divider, Image, Card, Label } from "semantic-ui-react";
const style = {
  placeholder: {
    minHeight: "100px"
  }
};
const projects = {
  highlights: {
    title: "Highlights",
    list: [
      {
        name: "Alex",
        url: "alex",
        date: "03/01/2018",
        cover:
          "https://firebasestorage.googleapis.com/v0/b/colorpallete-8e80c.appspot.com/o/cover%2Falex.png?alt=media&token=5b3314c1-7bb2-4978-8b4e-0b5b54effb53"
      },
      {
        name: "Tangible",
        url: "tangibleProject",
        date: "05/01/2017",
        ribbon: "Interactive",
        cover:
          "https://firebasestorage.googleapis.com/v0/b/colorpallete-8e80c.appspot.com/o/cover%2Ftangible.png?alt=media&token=ca10a8f8-6301-48d0-a1b9-935da6bffcd2"
      },
      {
        name: "Class Cloud",
        url: "class_cloud",
        cover:
          "https://firebasestorage.googleapis.com/v0/b/colorpallete-8e80c.appspot.com/o/cover%2Fclasscloud.png?alt=media&token=864011e3-df07-4a56-aa54-19da32797231",
        date: "06/01/2016"
      },
      {
        name: "English Duniya",
        url: "english_duniya",
        date: "03/01/2017",
        cover:
          "https://firebasestorage.googleapis.com/v0/b/colorpallete-8e80c.appspot.com/o/cover%2Fenglishduniya.png?alt=media&token=14fb7ec3-cce2-4261-ad46-de0b646bc506"
      }
    ]
  },
  others: {
    title: "Worth checking",
    list: [
      {
        name: "Shipmnt Product",
        url: "shipmnt",
        date: "03/01/2018",
        cover:
          "https://firebasestorage.googleapis.com/v0/b/colorpallete-8e80c.appspot.com/o/cover%2Fshipmnt.png?alt=media&token=00e11982-d718-4c50-8dba-6d830b5a083b"
      },
      {
        name: "Quiz Egg",
        url: "quiz_egg",
        date: "02/01/2017",
        cover:
          "https://firebasestorage.googleapis.com/v0/b/colorpallete-8e80c.appspot.com/o/cover%2Fquizegg.png?alt=media&token=f0d83128-6b34-4d0f-b8c1-54cf6802bd88"
      },
      {
        name: "Config App",
        url: "config_app",
        date: "12/01/2016",
        cover:
          "https://firebasestorage.googleapis.com/v0/b/colorpallete-8e80c.appspot.com/o/cover%2Fconfig.png?alt=media&token=1bd7fddd-c0cd-435d-a42a-5dcb2417f901"
      },
      {
        name: "Curate App",
        url: "curate_app",
        date: "06/01/2015",
        cover:
          "https://firebasestorage.googleapis.com/v0/b/colorpallete-8e80c.appspot.com/o/cover%2Fcurate.png?alt=media&token=b031e660-aaf3-4b52-9373-2e420dd62584"
      },
      {
        name: "Learn App",
        url: "learn_app",
        date: "12/01/2014",
        cover:
          "https://firebasestorage.googleapis.com/v0/b/colorpallete-8e80c.appspot.com/o/cover%2Flearn.png?alt=media&token=3c042ce1-e86a-4e00-a34d-9c388941c33f"
      }
    ]
  }
};
const OldProject = () => (
  <div>
    {/* Old stuff in one card */}
    <Divider horizontal>Old Projects</Divider>
    <Card fluid>
      <Card.Content>
        <Card.Header>Video Cable Communication</Card.Header>
        <Card.Meta>May 2013</Card.Meta>
        <Card.Description>
          Designed and developed a customer billing solution based on TRAI
          guidelines.
        </Card.Description>
      </Card.Content>
      <Card.Content>
        <Card.Header>Telibees Technologies Pvt Ltd</Card.Header>
        <Card.Meta>Jun 2012</Card.Meta>
        <Card.Description>
          Designed and developed mobile animations in SVG for different industry
          verticals.
        </Card.Description>
      </Card.Content>
      <Card.Content extra>
        <small>
          * The reason I smashed this into one section is because no links are
          available for these projects. So, you have to take my word for it :-)
        </small>
      </Card.Content>
    </Card>
  </div>
);
export default class ProjectList extends Component {
  state = {};
  openProject = url => {
    this.setState(prevState => {
      return { redirect: url };
    });
  };
  render() {
    const { redirect } = this.state;
    if (redirect) return <Redirect push to={`/project/${redirect}`} />;
    return (
      <div>
        <Divider hidden />
        {Object.values(projects).map(section => {
          return (
            <div key={section.title}>
              <Divider horizontal>{section.title}</Divider>
              {section.list.map((project, i) => {
                return (
                  <Card
                    fluid
                    key={i}
                    onClick={() => {
                      this.openProject(project.url);
                    }}
                  >
                    <Image
                      src={project.cover}
                      fluid
                      style={style.placeholder}
                      label={
                        project.ribbon && (
                          <Label color="blue" ribbon>
                            {project.ribbon}
                          </Label>
                        )
                      }
                    />
                    <Card.Content>
                      <Card.Header>{project.name}</Card.Header>
                      <Card.Meta>
                        {new Date(project.date).toLocaleDateString("en-HI", {
                          month: "short",
                          year: "numeric"
                        })}
                      </Card.Meta>
                    </Card.Content>
                  </Card>
                );
              })}
            </div>
          );
        })}
        <OldProject />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ProjectList.js